export default {
  "select-a-language": "выбор языка".toUpperCase(),
  select: "подтвердить".toUpperCase(),
  language: "русский".toUpperCase(),
};
